module.exports = __webpack_public_path__ + "public/img/banner-2.ce0033a6.jpg";